import styled from 'styled-components';
import { breakpoints } from 'theme';

export const ChatWrapper = styled.div`
  width: calc(100% - ${({ isMenuOpen = true }) => (isMenuOpen ? 360 : 60)}px);
  min-height: 100svh;
  background-color: white;
  margin-left: ${({ isMenuOpen }) => (isMenuOpen ? 360 : 60)}px;
  transition: all 0.3s;
  @media ${breakpoints.downMd} {
    width: 100%;
    margin-left: 0;
  }
`;
